export enum ETabBorderType {
  DEFAULT = 0,
  SUCCESS = 1,
  INFO = 2,
  WARN = 3,
  ERROR = 4,
}
